export default __webpack_public_path__ + "static/media/the_crew.2309ee78.png";